export function priceWithIVA(price: number): number {
    return price * 1.21;
}
